const EmailBoxType = {
    INBOX: "EmailBoxType.INBOX",
    DRAFTS: "EmailBoxType.DRAFTS",
    OUTBOX: "EmailBoxType.OUTBOX"
}

export default EmailBoxType;